import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TestimonialsService {
  
  constructor(private http: HttpClient) { }
}
